import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Gallery from "./pages/gallery/Gallery";
import Contact from "./pages/contact/Contact";
import Tour from "./pages/tour/Tour";
import Reservation from "./pages/reservation/Reservation";
// import { PopupButton } from "react-calendly";
import { Routes, Route, Navigate } from "react-router-dom";
import Footer from "./components/Footer";

function App() {
  return (
    <div
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      data-bs-title="Tooltip on top"
    >
      {/* <PopupButton
        url="https://calendly.com/sixthandmain/venue-reservation?hide_gdpr_banner=1"
        // //
        //  * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
        //  * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
        //  //
        pageSettings={{ primaryColor: "242424" }}
        rootElement={document.getElementById("root")}
        text="BOOK NOW ⇱"
        className="calendly-btn"
      /> */}
      <Routes>
        <Route
          path="/"
          element={<Home />}
        />
        <Route
          path="/about"
          element={<About />}
        />
        <Route
          path="/gallery"
          element={<Gallery />}
        />
        <Route
          path="/contact"
          element={<Contact />}
        />
        <Route
          path="/tour"
          element={<Tour />}
        />
        <Route
          path="/reservation"
          element={<Reservation />}
        />
        {/* Catch-all route to redirect invalid paths */}
        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace
            />
          }
        />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
